module.exports = __webpack_public_path__ + "img/weather18.be0bcf5a.png";